// extracted by mini-css-extract-plugin
export var subnav = "Navigation-module--subnav--7fd4a";